module.exports = __webpack_public_path__ + "media/images/team/jan-04f95a3844e386b294762f588d5f12af.jpg";